import {useAsyncRetry} from 'react-use';
import _ from 'lodash';
import {getGlobalAllows} from '@/api/clientApps';

export function useClientAppGlobalAllows(clientAppId) {
    return useAsyncRetry(() => {
        return getGlobalAllows(clientAppId).then(({data}) => {
            if (_.isString(data)) {
                return JSON.parse(data);
            }
            return data;
        });
    }, [clientAppId]);
}
